import React, { useEffect, useState } from "react";
import { useBranchManagement } from "./hooks/useBranchManagement";
import { useBranchForm } from "./hooks/useBranchForm";
import BranchToolbar from "./components/BranchToolbar";
import BranchList from "./components/BranchList";
import AddBranchModal from "./components/AddBranchModal";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import EditBranch from "./components/EditBranch";
import EditMenu from "../EditMenu";
import { useAddBranch } from "./hooks/useAddBranch";
import { useDeleteBranch } from "./hooks/useDeleteBranch";
import { PageTitle } from "src/shared/PageTitle";
import LoadingScreen from "src/shared/components/LoadingScreen";

const BranchesPage = () => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState<string | null>(null);

  const { branches, showDeletedBranches, handleCheckboxChange, deleteBranch, fetchBranches, loading } = useBranchManagement();

  const {
    formData,
    doberror,
    error,
    refs,
    updateFormData,
    resetForm,
    handleDobChange,
    handlePincodeChange,
    createKeyPressHandler,
    handleBranchnamesKeyPress,
  } = useBranchForm();

  const { addBranch } = useAddBranch(resetForm, fetchBranches, () => setAddModalOpen(false));
  const { selectedDelBranchId, setSelectedDelBranchId, handleDelete, confirmDelete } = useDeleteBranch(deleteBranch, fetchBranches);

  const branchName = branches.find((b) => b._id.$oid === selectedDelBranchId)?.Branch_name || "";
  const visible = !!formData.Branchname && !doberror;
  const menu = { Edit: "Edit" };

  useEffect(() => {
    document.title = "Branches › Settings › iMetanic";
  }, []);

  return (
    // <BusinessLayout businessType={businessType} pageType="Branches">
      <div className="setting-overall-container">
        <PageTitle title="- Settings › Branches" />
        <EditMenu editmenu={menu} />
        <BranchToolbar showDeletedBranches={showDeletedBranches} onCheckboxChange={handleCheckboxChange} onAddClick={() => setAddModalOpen(true)} />

      <BranchList
        branches={branches}
        showDeletedBranches={showDeletedBranches}
        onEdit={(branch) => {
          if (branch?._id?.$oid) {
            setSelectedBranchId(branch._id.$oid);
            setEditModalOpen(true);
          }
        }}
        onDelete={handleDelete}
      />

      <AddBranchModal
        open={addModalOpen}
        formData={formData}
        doberror={doberror}
        error={error}
        refs={refs}
        updateFormData={updateFormData}
        handleDobChange={handleDobChange}
        handlePincodeChange={handlePincodeChange}
        createKeyPressHandler={createKeyPressHandler}
        handleBranchnamesKeyPress={handleBranchnamesKeyPress}
        onClose={() => {
          setAddModalOpen(false);
          resetForm();
        }}
        onSubmit={() => addBranch(formData)}
        visible={visible}
      />

      {editModalOpen && selectedBranchId && (
        <EditBranch id={selectedBranchId} closeEdit={() => setEditModalOpen(false)} fetchBranches={fetchBranches} />
      )}

      <DeleteConfirmationModal
        open={!!selectedDelBranchId}
        onClose={() => setSelectedDelBranchId(null)}
        onConfirm={confirmDelete}
        branchName={branchName}
      />

      {loading && <LoadingScreen />}
      {/* <ToastContainer /> */}
    </div>
    // </BusinessLayout>
  );
};

export default BranchesPage;
